import { PurchaseOrderInvoiceDto } from './purchase-order-invoice.dto';


export class PurchaseOrderInvoiceManualUploadResponseDto {
  processed: PurchaseOrderInvoiceDto[];
  errors: ManualUploadError[]
}

export class ManualUploadError {
  invoiceNo: string;
  message: string;
  invoiceItem?: string;
}
